import { memo, type ReactNode } from 'react';

import { INFO_PANEL_DESCRIPTION } from '~/constants/testIDs';

type AssetTitleAndDescriptionContainerProps = {
  title: ReactNode;
  description: ReactNode;
};

export const AssetTitleAndDescriptionContainer = memo(
  ({ title, description }: AssetTitleAndDescriptionContainerProps) => {
    return (
      <div className="w-full ads:bg-raised bg-gray-2 px-6 py-4">
        {title}
        <div data-testid={INFO_PANEL_DESCRIPTION} className="mt-1 flex w-full shrink-0">
          {description}
        </div>
      </div>
    );
  },
);

AssetTitleAndDescriptionContainer.displayName = 'AssetTitleAndDescriptionContainer';
